import React, { FC } from 'react'
import { format } from 'date-fns'
import { CommonPageProps } from '../../../types/interface/fsm.interface'
import { LDCardTwoCol, LMBgHeader, Typography, withHidden } from '@dg-shared'
import { useTranslate } from '../../../hooks/shared'
import { LOGO_TEXT, TRANSLATIONS as T, FORMAT_YEAR_MONTH_DAY_HYPHEN } from '../../../constants'
import { MileageFormValues } from '../../../types/interface/form.interface'
import { removeAllSpaces } from '../../../service/util.service'
import useReactQueryPolicy from '../../../hooks/shared/useReactQueryPolicy'
import { Events } from '../../../FSM/shared/constants'
import { FSMService } from '../../../FSM'
import Mileage from '../../qb/Purchased/Content/Mileage'
import { logoMax, logoMin } from 'BrandedImages'
import LoadingPage from '../../qb/Loading/Page'

const MobileScreen = withHidden(LMBgHeader, true)
const DesktopScreen = withHidden(LDCardTwoCol, false)

const PagePolicyMileage: FC<CommonPageProps> = () => {
  const { t } = useTranslate('mileage')
  const { t: tPolicyReview } = useTranslate(T.POLICY_REVIEW)
  const { updateMileagePolicy, refetchPolicies, isLoading } = useReactQueryPolicy({
    policiesQueryEnabled: true,
  })

  const handleSubmit = async ({ mileage, readDate }: MileageFormValues) => {
    const mileageFormatted = parseInt(removeAllSpaces(mileage), 10)
    const dateFormatted = format(new Date(readDate), FORMAT_YEAR_MONTH_DAY_HYPHEN)

    await updateMileagePolicy({
      OdometerReading: mileageFormatted,
      DateOdometerReading: dateFormatted,
    })
    await refetchPolicies()
    await FSMService.flowService.send({ type: Events.DONE })
  }

  const title = tPolicyReview('card.sendMileage')
  const subtitle = t('form.annotation')

  const body = <Mileage handleSubmit={handleSubmit} />

  if (isLoading) {
    return <LoadingPage />
  }

  return (
    <>
      <MobileScreen
        headerTitle={title}
        headerSubTitle={subtitle}
        textLogoAlt={LOGO_TEXT}
        brandPageBackground='secondaryMobile'
        imageLogo={logoMin}
      >
        {body}
      </MobileScreen>
      <DesktopScreen
        textLogoAlt={title}
        imageLogo={logoMax}
        brandPageBackground='secondary'
        brandPageBackgroundCard='secondaryCard'
        isReverse
      >
        <div>
          <Typography type='h1'>{title}</Typography>
          <Typography type='h3'>{subtitle}</Typography>
        </div>
        {body}
      </DesktopScreen>
    </>
  )
}

export default PagePolicyMileage
